var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKirimPesanIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 14C12 13.4477 12.4477 13 13 13H19C19.5523 13 20 13.4477 20 14C20 14.5523 19.5523 15 19 15H13C12.4477 15 12 14.5523 12 14Z",
    fill: "#212121"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 17C12.4477 17 12 17.4477 12 18C12 18.5523 12.4477 19 13 19H17C17.5523 19 18 18.5523 18 18C18 17.4477 17.5523 17 17 17H13Z",
    fill: "#212121"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.00002 16C4.00002 9.37258 9.37262 4 16 4C22.6274 4 28 9.37258 28 16C28 22.6274 22.6274 28 16 28C13.8128 28 11.7598 27.414 9.99236 26.39L5.31626 27.9486C4.96434 28.066 4.5764 27.9788 4.30844 27.7224C4.0405 27.4658 3.9366 27.082 4.0385 26.7252L5.46172 21.744C4.5296 20.0372 4.00002 18.0791 4.00002 16ZM16 6C10.4772 6 6.00002 10.4772 6.00002 16C6.00002 17.8662 6.51026 19.6101 7.39826 21.1034C7.53904 21.34 7.57594 21.6244 7.50028 21.8892L6.48238 25.4518L9.79876 24.3464C10.084 24.2512 10.3969 24.2896 10.6507 24.4506C12.1971 25.4318 14.0307 26 16 26C21.5228 26 26 21.5228 26 16C26 10.4772 21.5228 6 16 6Z",
    fill: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKirimPesanIcon);
export default __webpack_public_path__ + "static/media/kirim-pesan-icon.93d01213fceab24638000b17cb9666fa.svg";
export { ForwardRef as ReactComponent };